<template>
  <section class="search--filters">
    <div class="hide--in-desktop hide--in-tablet">
      <div class="title--text">
        <div class="back--button hide--in-desktop hide--in-tablet" @click="close()">
          <img src="@/assets/img/icons/back-2.svg" />
        </div>
        <div class="d-flex justify-space-between align-center flex-grow-1">
          <div>
            {{
              isSecondary ? $t('general.filter.propertyFilter') : $t('general.filter.projectFilter')
            }}
          </div>
          <button type="button" class="clear--filter" @click="clearFilters()">
            {{ $t('general.filter.clearAll') }}
          </button>
        </div>
      </div>
    </div>
    <div class="filter--sidebar-content" v-if="$route.name !== 'search-user-listing'">
      <div class="hide--in-mobile">
        <div class="filter--panel-heading">
          <div>
            <div class="filter--eyebrow">Filter</div>
            <div class="filter--title">
              {{
                isSecondary
                  ? $t('general.filter.propertyFilter')
                  : $t('general.filter.projectFilter')
              }}
            </div>
          </div>
          <button type="button" class="btn clear--filter" @click="clearFilters()">
            {{ $t('general.filter.clearAll') }}
          </button>
        </div>
      </div>
      <region></region>
      <!--      <type v-if="isSecondary"></type>-->
      <!--      <rent-period v-if="type === 'R'"></rent-period>-->
      <property-type></property-type>
      <!--      <bedroom></bedroom>-->
      <!--      <sell-price></sell-price>-->
      <price-range></price-range>
      <!--      <div class="hide&#45;&#45;in-desktop hide&#45;&#45;in-tablet">-->
      <!--        <button class="btn btn-primary w-100" type="button" @click="applyFilters">-->
      <!--          {{ $t('general.filter.apply') }}-->
      <!--        </button>-->
      <!--      </div>-->
    </div>
    <div class="filter--footer hide--in-desktop hide--in-tablet" :class="{ active: isActive }">
      <button class="btn btn-primary" @click="applyFilters()">
        {{ $t('general.filter.apply') }}
      </button>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import PropertyType from '@/components/search-listing/partials/filters-sidebar/property-type';
import Region from '@/components/search-listing/partials/filters-sidebar/region.vue';
import PriceRange from '@/components/search-listing/partials/filters-sidebar/priceRange.vue';
export default {
  name: 'search-filters',
  components: {
    PriceRange,
    Region,
    PropertyType,
  },
  data: () => ({}),
  computed: {
    ...mapState({
      isActive: (state) => state.searchListing.activeFilterSidebar,
      selectedListingType: (state) => state.searchListing.selectedListingType,
      type: (state) => state.searchListing.type,
    }),
    ...mapGetters({
      isSecondary: 'searchListing/isSecondary',
    }),
  },
  methods: {
    close() {
      this.$store.commit('searchListing/SET_ACTIVE_FILTER_SIDEBAR', false);
    },
    clearFilters() {
      this.$store.commit('searchListing/CLEAR_FILTER');

      // APPLY FILTER ON CLEAR FILTER
      if (this.$mq !== 'xs') {
        this.$store.dispatch('searchListing/goToSearchPage', {
          router: this.$router,
          params: this.$route.params,
        });
      }
    },
    applyFilters() {
      this.close();
      this.$store.dispatch('searchListing/goToSearchPage', {
        router: this.$router,
        params: this.$route.params,
      });
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/utils/variables';

.search--filters {
  padding: 20px;
  color: #2d2d2d;
  font-family: Poppins, sans-serif;
}

.filter--panel-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 16px;
  margin-bottom: 18px;
  border-bottom: 1px solid #eeeeee;
}

.filter--eyebrow {
  margin-bottom: 4px;
  color: #9a9a9a;
  font-family: Poppins-SemiBold, sans-serif;
  font-size: 11px;
  line-height: 1;
  text-transform: uppercase;
}

.search--filters .filter--sidebar-content {
  .filter--title {
    margin: 0;
    color: #202020;
    font-family: Poppins-SemiBold, sans-serif;
    font-size: 17px;
    line-height: 1.25;
  }

  > .search-sidebar--single {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      padding-bottom: 0;
      margin-bottom: 0;
      border-bottom: none;
    }
  }

  .search-sidebar--single .filter--title {
    margin: 0 0 12px;
    color: #3a3a3a;
    font-family: Poppins-SemiBold, sans-serif !important;
    font-size: 14px !important;
    line-height: 1.35;
  }

  .clear--filter {
    min-height: 32px;
    padding: 0 10px;
    border: 1px solid #f0d6d6;
    border-radius: 999px;
    background: #ffffff;
    color: $color-beliruma-1;
    font-family: Poppins-SemiBold, sans-serif;
    font-size: 12px;
    text-decoration: none;
  }

  .v-input {
    border: 1px solid #e4e4e4 !important;
    border-radius: 13px !important;
    background: #ffffff;

    .v-input__slot {
      min-height: 46px;
      padding: 0 14px !important;
      box-shadow: none !important;
    }
  }

  .v-select__selection,
  .v-label {
    color: #6d6d6d;
    font-family: Poppins-SemiBold, sans-serif;
    font-size: 13px;
  }

  .property--type-filter {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 9px;

    .property--type {
      min-height: 62px;
      padding: 8px;
      border: 1px solid #e4e4e4;
      border-radius: 13px;
      background: #ffffff;
      color: #3f3f3f;
      font-family: Poppins-SemiBold, sans-serif;
      font-size: 12px;
      line-height: 1.2;
      box-shadow: none;
      transition: border-color 0.18s ease, background-color 0.18s ease, color 0.18s ease,
        transform 0.18s ease;

      &:hover {
        border-color: #cfcfcf;
        transform: translateY(-1px);
      }

      img {
        width: 20px;
        height: 20px;
        margin-bottom: 5px;
        opacity: 0.7;
      }

      &.selected {
        border-color: rgba(213, 18, 27, 0.34);
        background: #fff7f7;
        color: $color-beliruma-1;

        img {
          opacity: 0.9;
        }
      }
    }
  }
}

@media #{$phones} {
  .search--filters {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    padding: 0 18px;
    background: #fafafa;
  }

  .search--filters .title--text {
    position: sticky;
    top: 0;
    z-index: 3;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 18px 0 16px;
    margin: 0 0 16px;
    background: #fafafa;
    border-bottom: 1px solid #eeeeee;
    color: #202020;
    font-family: Poppins-SemiBold, sans-serif;
    font-size: 17px;

    .back--button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 38px;
      height: 38px;
      margin-right: 0;
      border: 1px solid #e7e7e7;
      border-radius: 12px;
      background: #ffffff;
      box-shadow: 0 6px 14px rgba(33, 33, 33, 0.05);

      img {
        width: 18px;
        height: 18px;
      }
    }

    .clear--filter {
      display: inline-flex;
      flex: 0 0 auto;
      align-items: center;
      justify-content: center;
      min-width: 126px;
      height: 36px;
      padding: 0 16px;
      border: 1px solid #f0d6d6;
      border-radius: 999px;
      background: #ffffff;
      color: $color-beliruma-1;
      font-family: Poppins-SemiBold, sans-serif;
      font-size: 12px;
      line-height: 1;
      text-decoration: none;
      white-space: nowrap;
      appearance: none;
    }
  }

  .search--filters .filter--sidebar-content {
    flex: 1 0 auto;
    padding: 0;

    > .search-sidebar--single {
      padding: 16px;
      margin-bottom: 12px;
      border: 1px solid #eeeeee;
      border-radius: 16px;
      background: #ffffff;
      box-shadow: 0 8px 20px rgba(33, 33, 33, 0.04);
    }

    .search-sidebar--single .filter--title {
      margin-bottom: 12px;
      font-size: 15px !important;
    }

    .property--type-filter {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 8px;

      .property--type {
        min-height: 58px;
        border-radius: 12px;
        font-size: 12px;
      }
    }

    .v-input .v-input__slot {
      min-height: 46px;
    }
  }

  .search--filters .filter--footer {
    position: sticky !important;
    display: block;
    left: auto !important;
    right: auto !important;
    bottom: 0;
    z-index: 4 !important;
    width: auto !important;
    margin: 8px -18px 0;
    padding: 14px 18px calc(14px + env(safe-area-inset-bottom));
    border-top: 1px solid #eeeeee;
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 -10px 26px rgba(33, 33, 33, 0.08);
    backdrop-filter: blur(10px);

    .btn {
      height: 46px;
      border-radius: 999px;
      background: $color-beliruma-1;
      border: none;
      font-family: Poppins-SemiBold, sans-serif;
      font-size: 14px;
    }
  }
}
</style>
